module.exports = __webpack_public_path__ + "img/categoryBread.5141768a.svg";